import React, { useState, useEffect, useRef } from 'react';
//import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

//import JoditEditor from "jodit-react";

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {

	reqGET,
	reqPOST,
	//reqDELETE,
	reqPUT,
	content_language,

} from '../../../Utils';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [meios_avaiable, set_meios_avaiable] = useState([])
	const [pistas_avaiable, set_pistas_avaiable] = useState([])

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	//const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)


	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const get_paied_orders = async (data) => {

		let n_forfaits = 0
		let n_equipments = 0
		let result = await reqGET(`${api_crud_base}/store/order/stats/day/${getTokenInfo().companycode}/${data}/paied`)

		if(result !== undefined && result !== null && result.data.length > 0) {
			for await(let el of result.data) {
				el.info.documento.linhas.forEach(el_l => {
					if(el_l.designacao.toLowerCase().includes('forfait')) {

						// console.log('el_l.designacao', el_l.designacao)
						// console.log('el_l.quantidade', el_l.quantidade)

						n_forfaits = parseInt(n_forfaits) + parseInt(el_l.quantidade)
					}
					if(el_l.designacao.toLowerCase().includes('equipamento')) {
						n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
					}
					if(el_l.designacao.toLowerCase().includes('capacete')) {
						n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
					}
					if(el_l.designacao.toLowerCase().includes('botas')) {
						n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
					}
					if(el_l.designacao.toLowerCase().includes('skis')) {
						n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
					}
					if(el_l.designacao.toLowerCase().includes('bast')) {
						n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
					}
					if(el_l.designacao.toLowerCase().includes('prancha')) {
						n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
					}
				})
			}


			// console.log('n_forfaits', n_forfaits)
			// console.log('n_equipments', n_equipments)


		}

		console.log('paied', result)
		return result

	}

	const verify_order_state_check = async (ano, mes, day) => {

		let result = await reqGET(`${api_crud_base}/store/order/year/month/check/${getTokenInfo().companycode}/${ano}/${mes}`) 
		console.log('check', result)

	}

	const verify_order_state_paied = async (ano, mes, day) => {

		let result = await reqGET(`${api_crud_base}/store/order/year/month/paied/${getTokenInfo().companycode}/${ano}/${mes}/${day}`) 
		console.log('paied', result)

	}

	const verify_order_state_used = async (ano, mes, day) => {

		let result = await reqGET(`${api_crud_base}/store/order/year/month/used/${getTokenInfo().companycode}/${ano}/${mes}/${day}`) 
		console.log('used', result)

	}

	const verify_order_state_all = async (ano, mes, day) => {

		let result = await reqGET(`${api_crud_base}/store/order/year/month/all/${getTokenInfo().companycode}/${ano}/${mes}/${day}`) 
		console.log('mes', mes)
		console.log('all', result)

	}

	useEffect(() => {
		clean_data();

        set_lang(localStorage.getItem('lang'))


		


		const get_meios_avaiable = async () => {
			return await reqGET(`${api_crud_base}/estancia/meio/${getTokenInfo().companycode}`)
				.then(res => {
					set_meios_avaiable(res.data)
				})
				.catch(error => console.log(error))
		}
	
		const get_pistas_avaiable = async (type, order) => {
			await reqGET(`${api_crud_base}/estancia/pista/type/${getTokenInfo().companycode}/${type}`)
				.then(res => {
					let x = []
					x[order] = res.data

					reqGET(`${api_crud_base}/estancia/pista/type/${getTokenInfo().companycode}/pista_natural`)
						.then(res => {
							
							x[order + 1] = res.data
		
		
							reqGET(`${api_crud_base}/estancia/pista/type/${getTokenInfo().companycode}/snowpark`)
								.then(res => {
									
									x[order + 2] = res.data

									set_pistas_avaiable(x)

									if(dados.current)
										setLoading(false)
									
								})
								.catch(error => console.log(error))
									
						})
						.catch(error => console.log(error))
				})
				.catch(error => console.log(error))
		}

		/*
		const get_pistas_avaiable = async (type, order) => {
			await reqGET(`${api_crud_base}/estancia/pista/type/${getTokenInfo().companycode}/${type}`)
				.then(res => {
					let x = []
					x[order] = res.data
					set_pistas_avaiable(x) 
				})
				.catch(error => console.log(error))
		}
		*/

		get_meios_avaiable()
		
		get_pistas_avaiable('pista_balizada', 0)
		// get_pistas_avaiable('pista_balizada', 0)
		// get_pistas_avaiable('pista_natural', 1)
		// get_pistas_avaiable('snowpark', 2)

		// let today = new Date().toISOString().split('T')[0]
		// let result = get_paied_orders('2024-03-19')
		// let result2 = get_paied_orders(today)

		// verify_order_state_check('2024', '03', '*')
		// verify_order_state_paied('2024', '01')
		// verify_order_state_used('2024', '02')
		// verify_order_state_all('2024', '01')
		// verify_order_state_all('2024', '02')
		// verify_order_state_all('2024', '03')

		try {

			const fetch_id_info = async (id_serch) => {

				return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
					.then(res => {
						set_dados(dados.current = res.data[0]);

					})
					.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
			}
			fetch_id_info('1').then(() => {
				set_is_edit(true)

			})

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					var today_submit = new Date()

					if(getTokenInfo().profile !== 'Administrador')
						dados.current.info.date = today_submit
	
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)

		console.log('name', name)
		console.log('value', value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_meteo = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info.meteo[name] = value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {

		console.log('handle_change_info_ckeditor', value);

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0 || dados.current.info.language[langid] === undefined || dados.current.info.language[langid] === null) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handleSingleCheckPistas = (e, el) => {
		const { name } = e.target;

		let x = dados.current.info.pistas.filter((v) => v.id === el.id)
		if(x.length === 0) {
			dados.current.info.pistas.push({id: el.id, state: true})
		}
		else {
			dados.current.info.pistas.forEach((v) => {
				if(v.id === el.id) {
					v.state = !v.state
				}
			})
		}

		set_dados(dados.current.info[name], )
	}

	const getCheckPistaValue = el => {
		let result = false

		let x = dados.current.info.pistas.filter((v) => v.id === el.id)
		if(x.length === 0) {

		}
		else {
			dados.current.info.pistas.forEach((v) => {
				if(v.id === el.id) {
					if(v.state === true) {
						//console.log('true', el.id + ' :: ' + v.id)
						result = true
					}
				}
			})
		}

		return result
	}
	
	const handleSingleCheckMeios = (e, el) => {
		const { name } = e.target;

		let x = dados.current.info.meios.filter((v) => v.id === el.id)
		if(x.length === 0) {
			dados.current.info.meios.push({id: el.id, state: true})
		}
		else {
			dados.current.info.meios.forEach((v) => {
				if(v.id === el.id) {
					v.state = !v.state
				}
			})
		}

		set_dados(dados.current.info[name], )
	}

	const getCheckMeioValue = el => {
		let result = false

		let x = dados.current.info.meios.filter((v) => v.id === el.id)
		if(x.length === 0) {

		}
		else {
			dados.current.info.meios.forEach((v) => {
				if(v.id === el.id) {
					if(v.state === true) {
						//console.log('true', el.id + ' :: ' + v.id)
						result = true
					}
				}
			})
		}

		return result
	}

	const get_value_info_lang = (order, langid, name) => {
		if (dados.current.info['language'] !== undefined && dados.current.info['language'] !== null) {
			if (dados.current.info['language'][langid] !== undefined && dados.current.info['language'][langid] !== null) {
				return dados.current.info['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const get_value_info_store_lang = (order, langid, name) => {
		if (dados.current.info.store['language'] !== undefined && dados.current.info.store['language'] !== null) {
			if (dados.current.info.store['language'][langid] !== undefined && dados.current.info.store['language'][langid] !== null) {
				return dados.current.info.store['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const handleSingleCheckStore = e => {
		const { name } = e.target;

		set_dados(dados.current.info.store.state = !dados.current.info.store.state)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados.current))

	}

	const handle_change_info_store_ckeditor = (value, order, langid, lang, name) => {

		console.log('handle_change_info_store_ckeditor', value);

		if (langid === '1') {
			set_dados(dados.current.info.store[name] = value)
		}
		else {
			if (dados.current.info.store['language'] === undefined)
				dados.current.info.store['language'] = []

			if (dados.current.info.store.language.length === 0 || dados.current.info.store.language[langid] === undefined || dados.current.info.store.language[langid] === null) {
				dados.current.info.store.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info.store['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className='card'>

									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].component}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0 d-none">
												{
												content_language.length > 1 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
													:
													''
												}
											</ul>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																	<div className="row mb-3 d-none">
																		<div className="col-md-8">
																			<label className={"fs-5 mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="name" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.name : get_value_info_lang('0', el_lang.id, 'name')} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required={el_lang.id === '1' && 0 ? 'required' : ''} />
																		</div>

																		<div className="col-md-4">
																			<label className="fs-5 mb-2">{language[lang].field_abreviation} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="abreviation" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																		</div>

																	</div>

																	<div className="row mb-5">
																		<div className="col-3 col-md-2">
																			<label className={"fs-5 mb-2 d-none"}>{language[lang].field_min}</label>
																			<h4>{language[lang].field_min}</h4>
																			
																			{
																			false ?
																				<div className="row g-3 align-items-center">
																					<div className="col-auto">
																						<input type="text" name="min" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.meteo.min} className="form-control text-end" aria-describedby="minHelpInline" placeholder={language[lang].field_min_placeholder} onChange={handle_change_info_meteo} />
																					</div>
																					<div className="col-auto">
																						<span id="minHelpInline" className="form-text">
																						ºC
																						</span>
																					</div>
																				</div>
																			:
																				null
																			}

																			<div className="input-group mb-3">
																				<input type="text" name="min" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.meteo.min} className="form-control text-end"  aria-describedby="minHelpInline" placeholder={language[lang].field_min_placeholder} onChange={handle_change_info_meteo} />
																				<span className="input-group-text" id="minHelpInline">ºC</span>
																			</div>


																		</div>

																		<div className="col-3 col-md-2">
																			<label className="fs-5 mb-2 d-none">{language[lang].field_max}</label>
																			<h4>{language[lang].field_max}</h4>

																			{
																			false ?
																				<div className="row g-3 align-items-center">
																					<div className="col-auto">
																						<input type="text" name="max" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.meteo.max} className="form-control text-end" aria-describedby="maxHelpInline" placeholder={language[lang].field_max_placeholder} onChange={handle_change_info_meteo} />
																					</div>
																					<div className="col-auto">
																						<span id="maxHelpInline" className="form-text">
																						ºC
																						</span>
																					</div>
																				</div>
																			:
																				null
																			}

																			<div className="input-group mb-3">
																				<input type="text" name="max" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.meteo.max} className="form-control text-end" aria-describedby="maxHelpInline" placeholder={language[lang].field_max_placeholder} onChange={handle_change_info_meteo} />
																				<span className="input-group-text" id="maxHelpInline">ºC</span>
																			</div>
																		</div>

																		<div className="col-3 col-md-2">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_store_state}</label>
																			<div className="input-group">
																				<label className="switch">
																					<input
																						id={'item-switch-store'}
																						name={"store"}
																						className=""
																						type="checkbox"
																						value={dados.current.info.store !== undefined && dados.current.info.store !== null ? dados.current.info.store.state : false}
																						onChange={handleSingleCheckStore}
																						defaultChecked={dados.current.info.store !== undefined && dados.current.info.store !== null ? dados.current.info.store.state : false}
																					/>
																					<span className="slider round" htmlFor={'item-switch-store'}></span>
																				</label>
																			</div>
																		</div>

																		<div className='col-6'>
																			<label className="fs-6 fw-bold mb-2">Mensagem para Loja</label>

																			<AssecCKEditor
																				name={"store_msg"}
																				content={el_lang.id === '1' ? dados.current.info.store.store_msg : get_value_info_store_lang('0', el_lang.id, 'store_msg')}
																				func={(e) => handle_change_info_store_ckeditor(e, '0', el_lang.id, el_lang.code, 'store_msg')}
																			/>
																			<textarea className="form-control d-none" type="store_msg" name="store_msg" value={dados.current.info.store_msg} placeholder={language[lang].field_store_msg_placeholder} onChange={handle_change_info} />
																		</div>

																		<div className="col-md-3 d-none">
																			<label className="fs-5 mb-2">{language[lang].field_snow}</label>
																			<input type="text" name="snow" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.meteo.snow} className="form-control" placeholder={language[lang].field_snow_placeholder} onChange={handle_change_info_meteo} />
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-12 mb-5">
																			<div className="row">
																				<h4>{language[lang].pista_balizada}</h4>
																				{
																				pistas_avaiable[0] !== undefined ?	
																					pistas_avaiable[0].map((el, k) => {
																						return (
																							<div key={k} className="col-3">
																								<div className="form-check form-switch mt-3 form-check form-switch mt-3 d-flex justify-content-start align-items-center">
																									<input 
																										id={'item-pb-' + el.id} 
																										className="form-check-input" 
																										type="checkbox" 
																										style={{width: '60px', height: '34px'}}
																										name={"pista"}
																										value={el.id} 
																										onChange={(e) => handleSingleCheckPistas(e, el)}
																										defaultChecked={getCheckPistaValue(el)}
																									/> 
																									<label className="form-check-label ms-3" htmlFor={'item-pb-' + el.id}>{el.info.name}</label>
																								</div>
																							</div>
																						)
																					})
																				:
																					null
																				}
																			</div>
																		</div>
																		<div className="col-12 mb-5">
																			<div className="row">
																				<h4>{language[lang].pista_natural}</h4>
																				{
																				pistas_avaiable[1] !== undefined ?	
																					pistas_avaiable[1].map((el, k) => {
																						return (
																							<div key={k} className="col-3">
																								<div className="form-check form-switch mt-3 form-check form-switch mt-3 d-flex justify-content-start align-items-center">
																									<input 
																										id={'item-pn-' + el.id} 
																										className="form-check-input" 
																										type="checkbox" 
																										style={{width: '60px', height: '34px'}}
																										name={"pista"}
																										value={el.id} 
																										onChange={(e) => handleSingleCheckPistas(e, el)}
																										defaultChecked={getCheckPistaValue(el)}
																									/>
																									<label className="form-check-label ms-3" htmlFor={'item-pn-' + el.id}>{el.info.name}</label>
																								</div>
																							</div>
																						)
																					})
																				:
																					null
																				}
																			</div>
																		</div>
																		<div className="col-12 mb-5">
																			<div className="row">
																				<h4>{language[lang].snowpark}</h4>
																				{

																				pistas_avaiable[2] !== undefined ?	
																					pistas_avaiable[2].map((el, k) => {
																						return (
																							<div key={k} className="col-3">
																								<div className="form-check form-switch mt-3 form-check form-switch mt-3 d-flex justify-content-start align-items-center">
																									<input 
																										id={'item-sp-' + el.id} 
																										className="form-check-input" 
																										type="checkbox" 
																										style={{width: '60px', height: '34px'}}
																										name={"pista"}
																										value={el.id} 
																										onChange={(e) => handleSingleCheckPistas(e, el)}
																										defaultChecked={getCheckPistaValue(el)}
																									/>
																									<label className="form-check-label ms-3" htmlFor={'item-sp-' + el.id}>{el.info.name}</label>
																								</div>
																							</div>
																						)
																					})
																				:
																					null
																				}
																			</div>
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-12 mb-5">
																			<div className="row">
																				<h4>{language[lang].meios_mecanicos}</h4>
																				{
																				meios_avaiable.map((el, k) => {
																					return (
																						<div key={k} className="col-3">
																							<div className="form-check form-switch mt-3 form-check form-switch mt-3 d-flex justify-content-start align-items-center">
																								<input 
																									id={'item-m-' + el.id} 
																									className="form-check-input" 
																									type="checkbox" 
																									style={{width: '60px', height: '34px'}}
																									name={"meio"}
																									value={el.id} 
																									onChange={(e) => handleSingleCheckMeios(e, el)}
																									defaultChecked={getCheckMeioValue(el)}
																								/> 
																								<label className="form-check-label ms-3" htmlFor={'item-m-' + el.id}>{el.info.name}</label>
																							</div>
																						</div>
																					)
																				})
																				}
																			</div>
																		</div>
																	</div>

																	<div className="row mb-3">
																		<div className="col-md-12">
																			<label className="fs-5 fw-bold mb-2">{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																			<AssecCKEditor
																				name={"text"}
																				content={el_lang.id === '1' ? dados.current.info.description : get_value_info_lang('0', el_lang.id, 'description')}
																				func={(e) => handle_change_content_ckeditor(e, '0', el_lang.id, el_lang.code, 'description')}
																			/>

																			<textarea className="form-control d-none" type="description" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																		</div>
																	</div>
																</div>
															)
														})
													:
														<div className={"tab-pane show active"} role="tabpanel">
															<div className="row mb-3 d-none">
																<div className="col-md-8">
																	<label className="fs-5 required fw-bold mb-2">{language[lang].field_name}</label>
																	<input type="text" name="name" data-langid={'1'} data-lang={'pt'} value={dados.current.info.name} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required />
																</div>

																<div className="col-md-4">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_abreviation}</label>
																	<input type="text" name="abreviation" data-langid={'1'} data-lang={'pt'} value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																</div>
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_canhoes}</label>
																	<div className="input-group">
																		<label className="switch">
																			<input
																				id={'item-switch-canhoes'}
																				name={"canhoes"}
																				className=""
																				type="checkbox"
																				value={true}
																				onChange={handleSingleCheckStore}
																				defaultChecked={true}
																			/>
																			<span className="slider round" htmlFor={'item-switch-canhoes'}></span>
																		</label>
																	</div>
																</div>
															</div>

															<div className="row mb-3">
																<div className="col-md-12">
																	<label className="fs-5 fw-bold mb-2">{language[lang].field_description}</label>

																	<AssecCKEditor
																		name={"text"}
																		content={dados.current.info.description}
																		func={(e) => handle_change_content_ckeditor(e, '0', '1', 'pt', 'description')}
																	/>

																	<textarea className="form-control d-none" type="description" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																</div>
															</div>
														</div>
													}
												</div>
											</div>
										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
